import { Alert } from "@circleco/compass/components/Alert";

import { t } from "@/i18n-js/instance";
import type { ContactSnapshot } from "@/react/types/FlaggedContent";

const i18nRoot = "settings.moderation.review_flagged_content_modal";

interface ContactSnapshotAlertProps {
  authorName: string;
  contactSnapshot: ContactSnapshot;
}

export const ContactSnapshotAlert = ({
  authorName,
  contactSnapshot,
}: ContactSnapshotAlertProps) => {
  const {
    post = 0,
    comment = 0,
    connect_connection = 0,
    chat_room_message: chatRoomMessage = 0,
  } = contactSnapshot;
  const totalCount = post + comment + connect_connection + chatRoomMessage;

  if (totalCount === 0) {
    return null;
  }

  const otherCount = totalCount - 1;
  const titleKey = otherCount > 0 ? "other_reports_title" : "reports_title";
  const displayCount = otherCount > 0 ? otherCount : totalCount;

  const description = [
    t([i18nRoot, "contact_snapshot", "posts"], { count: post }),
    t([i18nRoot, "contact_snapshot", "comments"], { count: comment }),
    t([i18nRoot, "contact_snapshot", "connection_requests"], {
      count: connect_connection,
    }),
    t([i18nRoot, "contact_snapshot", "chat_messages"], {
      count: chatRoomMessage,
    }),
  ].join(" · ");

  return (
    <Alert
      variant="warning"
      iconColor="warning"
      title={t([i18nRoot, "contact_snapshot", titleKey], {
        name: authorName,
        count: displayCount,
      })}
      description={description}
      icon="triangle-exclamation"
    />
  );
};
